module.exports = __webpack_public_path__ + "media/assets/icons/checkmark-2cd1c874ea743c8d07b32b5c96661541.svg";